import React from "react";
import LandingFooter from "../../../pages/welcome/components/LandingFooter";
import { getDefaultSiteFooter } from "../../../../config/siteFooter";

const Footer = () => <LandingFooter footer={getDefaultSiteFooter()} />;

export default Footer;
